<script>
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  const user = {
    identity: null,
  }

  function sendUser() {
    dispatch('formEdited', user)
  }
</script>

<label class="auth__label" for="email">

  Email Address

  <div class="auth__input">

    <input type="text" name="email" on:keyup={sendUser} placeholder="Your email..." bind:value={user.identity} id="email" required>

  </div>

</label>